/**
 * Exports dropdown-related design tokens
 */

export const defaultPopoverBreakpoint = 'large';
